<template>
  <div class="item" @click="toDetail(item)">
    <div class="item_img">
      <img :src="item.goodsImage" alt="商品图片">
    </div>
    <div class="item_content">
      <div class="goodsName f14">
        <div v-if="source==='ALI'&&item.goodsType==='0'" class="_source_icon">淘宝</div>
        <div v-if="source==='ALI'&&item.goodsType==='1'" class="_source_icon">天猫</div>
        <div v-if="source==='JD'" class="_source_icon">京东</div>
        <div v-if="source==='PDD'" class="_source_icon">拼多多</div>
        <div v-if="source==='YD'" class="_source_icon">云店</div>
        {{ item.goodsName }}
      </div>
      <div class="flex space_between">
        <div style="flex: 1;">
          <div class="flex space_between">
            <span class="price f12 _app">￥{{ item.price }}</span>
            <span class="_oriPrice f14">￥{{ item.oriPrice }}</span>
          </div>
          <div class="flex space_between">
            <!-- <div class="f10" v-if="source==='YD'">标签TAG</div> -->
            <div class="f10 gray_f">已售 {{ item.saleVolume }}</div>
          </div>
          <div class="flex space_between bottom">
            <div class="f10 _tongBan">{{ item.tongBan }}铜板</div>
            <div class="f10 _coupon">{{ item.coupon }}元券</div>
          </div>
        </div>
        <div class="item_pick" v-if="layoutType==='2'">
          <div class="_btn_pick f14" @click.stop="doPick" v-if="source==='YD'&&item.isProxy==='true'">我要选货</div>
          <div class="_btn_pick f14" @click.stop="doPick" v-if="source==='ALI'">我要选货</div>
          <div class="_btn_pick f14" @click.stop="doPick" v-if="source==='JD'">我要选货</div>
          <div class="_btn_pick f14" @click.stop="doPick" v-if="source==='PDD'">我要选货</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "goodsItem",
  props: {
    item: Object, //商品item数据
    layoutType: String, //布局方式：1 横排列表,2 横排列表带一个按钮
    btnAction: String,//按钮操作：
    source: String //来源：YD 云店，ALI 淘宝/天猫，JD 京东，PDD 拼多多
  },
  data() {
    return {}
  },
  methods: {
    toDetail(item) {
      let url = ''
      if (this.source === 'YD') {
        this.$router.push({path: '/whyd/ydDetail', query: {ydId: this.item.goodsId}})
      } else if (this.source === 'ALI') {
        // url = '/union/tao/taoDetail?taoId=' + item.goodsId
        this.$router.push({path: '/union/tao/taoDetail', query: {taoId: this.item.goodsId}})
      } else if (this.source === 'PDD') {
        // url = '/union/pdd/pddDetail?pddId=' + item.goodsSign
        this.$router.push({path: '/union/pdd/pddDetail', query: {pddId: this.item.goodsSign}})
      } else if (this.source === 'JD') {
        // url = '/union/jd/jdDetail?jdId=' + item.goodsId
        this.$router.push({path: '/union/jd/jdDetail', query: {jdId: this.item.goodsId}})
      }
    },
    doPick() {
      //父组件的事件doPick提交参数item
      this.$emit('bindPick', this.item)
    }
  }
}

</script>
<style scoped lang="less">
.item {
  padding: 0 10px;
  display: flex;
  justify-content: stretch;
  align-items: flex-start;
  margin-bottom: 5px;
}

.item_img {
  width: 120px;
  height: 120px;

  img {
    width: 120px;
    height: 120px;
  }
}

.item_content {
  flex: 1;
  margin-left: 5px;
  height: 120px;
  line-height: 22px;
}

/*商品标题*/
.goodsName {
  display: block;
  width: 100%;
  height:  44px;
  line-height:  22px;
  overflow: hidden;
  font-weight: bold;
  text-align: left;
}

/*我要选货按钮*/
.item_pick {
  padding: 0 1%;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/goodsItem.vue